module.exports = __webpack_public_path__ + "static/media/Apple iPhone X Silver.f3da45fc.png";